import { render, staticRenderFns } from "./TicketQuestions.vue?vue&type=template&id=027189c1&"
import script from "./TicketQuestions.vue?vue&type=script&lang=js&"
export * from "./TicketQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports